'use client';

import { App_text } from '@/settings/AppText';
import { Routes } from '@/settings/routes';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React from 'react';

export default function ButtonTailorMade() {
    const route = usePathname();

    return (
        route !== Routes.FRONT_tailor_made && (
            <div className="fixed bottom-0 left-0 z-50 p-4 w-full lg:hidden">
                <style>{`
                    .fixed-cta-pill {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        gap: 10px;
                        width: 100%;
                        height: 52px;
                        border-radius: 9999px;
                        border: none;
                        background: linear-gradient(135deg, #E8604C 0%, #313041 100%);
                        color: #ffffff;
                        font-size: 0.95rem;
                        font-weight: 600;
                        text-decoration: none;
                        text-transform: capitalize;
                        box-shadow: 0 8px 28px rgba(232,96,76,0.45), 0 2px 8px rgba(0,0,0,0.15);
                        transition: box-shadow 0.25s ease, transform 0.2s ease;
                        cursor: pointer;
                    }
                    .fixed-cta-pill:hover {
                        box-shadow: 0 12px 36px rgba(232,96,76,0.6), 0 4px 12px rgba(0,0,0,0.2);
                        transform: translateY(-1px);
                    }
                    .fixed-cta-pill svg {
                        transition: transform 0.2s ease;
                    }
                    .fixed-cta-pill:hover svg {
                        transform: translateX(4px);
                    }
                `}</style>

                <Link prefetch={false} href={Routes.FRONT_tailor_made} aria-label={App_text.generale.navbar.button_action} className="fixed-cta-pill">
                    <span>{App_text.generale.navbar.button_action}</span>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                    </svg>
                </Link>
            </div>
        )
    );
}
